module.exports = __webpack_public_path__ + "static/media/blackinstagram.344fea7e.png";